import Content from "../../common/Content";
import Button from "../../ui/Button";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrow-right.svg";
import DifficultySelector from "../../ui/DifficultySelector";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import GameArea from "../../ui/GameArea";
import PlayButton from "../../ui/PlayButton";
import FingerSkillsLevel from "../FingerSkills/FingerSkillsLevel";
import ContentCenter from "../../ui/ContentCenter";
import ArmsUpLevel from "../ArmsUp/ArmsUpLevel";
import styled, { css } from "styled-components";
import { shuffle } from "lodash";
import { useDrag } from "react-dnd";
import ScrambleLetter from "./ScrambleLetter";
import ScrambleBlank from "./ScrambleBlank";

const ScrambleLetters: any = styled.div`
  display: flex;

  img {
    width: 32px;
    height: 32px;
    margin: 0 1px;
  }

  ${(p: any) =>
    p.scrambled &&
    css`
      > div {
        position: absolute;
      }

      .l-0 {
        top: 10px;
        left: 70px;
      }

      .l-1 {
        top: 20px;
        left: 10px;
      }

      .l-2 {
        top: 240px;
        left: 40px;
      }

      .l-3 {
        top: 280px;
        left: 260px;
      }

      .l-4 {
        top: 300px;
        left: 90px;
      }

      .l-5 {
        top: 290px;
        left: 180px;
      }

      .l-6 {
        top: 90px;
        left: 450px;
      }

      .l-7 {
        top: 20px;
        left: 320px;
      }

      .l-8 {
        top: 43px;
        left: 250px;
      }

      .l-9 {
        top: 21px;
        left: 193px;
      }

      .l-10 {
        top: 313px;
        left: 393px;
      }

      .l-11 {
        top: 213px;
        left: 293px;
      }

      .l-12 {
        top: 63px;
        left: 323px;
      }

      .l-13 {
        top: 4px;
        left: 354px;
      }
    `}
`;

const ScrambleInput: any = styled.div``;

export default ({ word, scrambled, disabled, nextWord }: any) => {
  const [chars, setChars] = useState<string[]>(shuffle(word.split("")));
  const [currentWord, setCurrentWord] = useState(
    chars.map((e) => " ").join("")
  );
  const [blacklist, setBlacklist] = useState<any>([]);

  useEffect(() => {
    const shuffled = shuffle(word.split(""));
    setChars(shuffled);
    setCurrentWord(shuffled.map((e) => " ").join(""));
    setBlacklist([]);
  }, [word]);

  const onDrop = (ev: any, index: number) => {
    const { char, index: charIndex } = ev;
    if (currentWord[index] !== " ") {
      return;
    }

    if (word[index] === char) {
      const updatedCurrentWord = currentWord.split("");
      updatedCurrentWord[index] = char;
      setCurrentWord(updatedCurrentWord.join(""));
      const updatedChars = chars;
      updatedChars[charIndex] = " ";
      setChars(updatedChars);

      setBlacklist([...blacklist, ev]);
    }

    return undefined;
  };

  const isBlacklisted = (char: any, index: any) => {
    return blacklist.find(
      (test: any) => test.char === char && test.index === index
    );
  };

  return (
    <>
      <ContentCenter
        column
        style={{
          position: "relative",
          height: "100%",
          opacity: disabled ? 0.5 : 1.0,
          pointerEvents: disabled ? "none" : "all",
        }}
      >
        <ScrambleLetters scrambled={scrambled}>
          {chars.map((char, index) => (
            <ScrambleLetter
              blacklist={isBlacklisted(char, index)}
              key={"u" + char + index}
              char={char}
              index={index}
            />
          ))}
        </ScrambleLetters>
        <ScrambleLetters>
          {word.split("").map((char: any, index: number) =>
            currentWord[index] === char ? (
              <div>
                <ScrambleLetter
                  pin={true}
                  key={"vx" + char + index}
                  char={char}
                />
              </div>
            ) : (
              <div>
                <ScrambleBlank
                  key={"v" + char + index}
                  onDrop={(ev: any) => onDrop(ev, index)}
                />
              </div>
            )
          )}
        </ScrambleLetters>
        {currentWord === word ? (
          <PlayButton onClick={nextWord}>
            Geschafft! Nächster Begriff
          </PlayButton>
        ) : (
          <></>
        )}
      </ContentCenter>
    </>
  );
};
